export default __webpack_public_path__ + "static/media/Circle.4a62678e.svg";